// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__2Byda","title":"AfterBackImages_title__3RUej","images":"AfterBackImages_images__2ZQIU"};